import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { withSagas } from 'decorators/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { isMobileDevice } from 'helpers/isMobile';
import { composeValidators, emailValidator, requiredValidator, validateFields } from 'validators';
import { InputField } from 'components/FormFields/InputField';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';
import { Toggle } from './Toggle';
import { LEAD_FORM, initializeLeadForm, leadFormAction, watchLeadFormSagas } from '../sagas/lead.saga';

const messages = defineMessages({
  emailPlaceholder: {
    id: 'signup-card.lead.email-placeholder',
    defaultMessage: 'Email address',
  },
});

export class LeadFormUnwrapped extends PureComponent {
  componentDidMount() {
    this.props.onMount(this.props.hiddenFields);
  }

  renderMarketingDisclaimer() {
    const { marketingOptOutDisclaimer, marketingOptInDisclaimer } = this.props;
    const disclaimer = marketingOptOutDisclaimer || marketingOptInDisclaimer;
    if (disclaimer) {
      return (
        <div className="qa-marketing-disclaimer text--xs text--left">
          <LocalizableMessage message={disclaimer}>
            {msg => (
              <Field
                className="marketing-disclaimer-toggle"
                component={Toggle}
                label={msg}
                name={marketingOptOutDisclaimer ? 'marketingOptOut' : 'marketingOptIn'}
              />
            )}
          </LocalizableMessage>
        </div>
      );
    }
  }

  render() {
    const { formId, handleSubmit, intl, searchableDisclaimer } = this.props;

    return (
      <form className="form" id={formId} method="post" noValidate onSubmit={handleSubmit}>
        <Field
          component={InputField}
          name="email"
          showSubmitErrorWhenActive
          inputAttributes={{
            type: 'email',
            placeholder: intl.formatMessage(messages.emailPlaceholder),
            // Only auto focus on desktop, to prevent unwanted keyboard popup covering page content
            autoFocus: !isMobileDevice(),
          }}
        />
        {this.renderMarketingDisclaimer()}
        {searchableDisclaimer && (
          <div className="qa-searchable-disclaimer text--xs text--left">
            <LocalizableMessage message={searchableDisclaimer}>
              {msg => (
                <Field className="searchable-disclaimer-toggle" component={Toggle} label={msg} name="searchable" />
              )}
            </LocalizableMessage>
          </div>
        )}
      </form>
    );
  }
}

LeadFormUnwrapped.propTypes = {
  formId: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  hiddenFields: PropTypes.object,
  intl: intlShape,
  marketingOptInDisclaimer: PropTypes.string,
  marketingOptOutDisclaimer: PropTypes.string,
  onMount: PropTypes.func.isRequired,
  searchableDisclaimer: PropTypes.string,
};

const formConfig = {
  enableReinitialize: true,
  form: LEAD_FORM,
  keepDirtyOnReinitialize: true,
  onSubmit: leadFormAction,
  onSubmitSuccess: (result, dispatch, props) => props.onSuccess(result),
  validate: composeValidators(validateFields(requiredValidator, ['email']), validateFields(emailValidator, ['email'])),
};

const mapStateToProps = state => {
  const leadFormValues = getFormValues(LEAD_FORM)(state) || {};
  return {
    marketingOptInDisclaimer: leadFormValues.marketingOptInDisclaimer,
    marketingOptOutDisclaimer: leadFormValues.marketingOptOutDisclaimer,
    searchableDisclaimer: leadFormValues.searchableDisclaimer,
  };
};

export const LeadForm = decorateWith(
  withSagas({ watch: watchLeadFormSagas }),
  connect(
    mapStateToProps,
    { onMount: initializeLeadForm }
  ),
  injectIntl,
  reduxForm(formConfig),
  withName('LeadForm')
)(LeadFormUnwrapped);
